import { Component, EventEmitter, Input, OnInit, Output, HostListener, ChangeDetectorRef, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MasterSummaryPDModel, MasterSummaryQuestionModel } from '../../../../models/survey/survey.model';
import { IncludeSurveyModel, SummaryFilterModel, SurveyVersionModelCore } from '../../../../models/summary/summary.model';
import { HideQuestionModel } from '../../../../models/hide-question/hide-question.model';
import { SortType } from '../../../../shared/constants/sort.constants';
import { getCanvasIdForAllCharts } from '../../../../shared/helpers/chart-helper';
import { SurveyService } from '../../surveys.service';
import { SurveyUserSettingModel } from '../../../../models/survey-user-setting/survey-user-setting.model';
import { CommunicationService } from '../../../../shared/services/communication.service';

@Component({
  selector: 'app-compare-version',
  templateUrl: './compare-version.component.html',
  styleUrls: ['./compare-version.component.less']
})
export class CompareVersionComponent implements OnInit, AfterViewInit {

  @Input() surveyMasterSummaryPDModel: MasterSummaryPDModel;
  @Input() includeSurvey: IncludeSurveyModel;
  @Output() onHideQuestion: EventEmitter<number> = new EventEmitter<number>();
  @Output() onTranslate: EventEmitter<string> = new EventEmitter<string>();  
  @Output() onChangeQuestionSetting: EventEmitter<MasterSummaryPDModel> = new EventEmitter<MasterSummaryPDModel>();  
  @Input() hideQuestions: HideQuestionModel[] = [];
  @Input() missingQuestionIds: number[] = [];
  @Input() compareSurveyDataModel: MasterSummaryPDModel;
  @Input() surveyId: number;
  @Input() summaryFilterModel: SummaryFilterModel;
  @Input() surveyUserSetting: SurveyUserSettingModel;
  @Input() isShowExploreCompareChartsMode: boolean;

  _compareIndex = 0;
  _indexChangeChartType = -1;
  _index = -1;
  sortModeSelect: string
  themeModeSelect = true;
  dataOrdered: any;
  init = false;

  @Input()
  get compareIndex(): any {
    return this._compareIndex;
  }

  set compareIndex(val: any) {
    if (typeof val !== 'number' && val) {
      this._compareIndex = val.value;
      this.oldPosition = -1;
    } else {
      this._compareIndex = val;
    }
  }

  showUnhideDialog = false;
  unhideQuestionId: number;
  chartModeSelect: string;
  numberItemsEachLazyLoad = 1;
  showQuestion = true

  onLoadMore = false;

  version: SurveyVersionModelCore = { surveyName: 'ALL RESPONSES', hash: '', isSelected: true, missingQuestionIds: null };

  showDownloadAllChartsIcon = false;

  constructor(private cdRef:ChangeDetectorRef, private surveyService: SurveyService, private communicationService: CommunicationService) {
  }

  oldPosition = -1;
  @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    const currentH = document.documentElement.scrollTop;
    if (currentH !== this.oldPosition) {
      const diffH = currentH - this.oldPosition;
      if ( diffH > 0 && diffH / 400 > 1) {
        this.onScroll(2);
        this.oldPosition = currentH;
      } if (Math.abs(diffH) > 200 ) {
        this.onScroll();
        this.oldPosition = currentH;
      }
      this.communicationService.scrollDataChanged.next();
    }
  }
  compareDefaultChart: string

  ngOnInit() {
    const countVersion = this.includeSurvey.listSurveyVersion ? this.includeSurvey.listSurveyVersion.length : 0;
    const countCut = this.includeSurvey.listSurveyCut ? this.includeSurvey.listSurveyCut.length : 0;
    const count = countVersion + countCut + (this.includeSurvey.allResponsesSelected ? 1 : 0);
    this.showDownloadAllChartsIcon = count > 1 ? true : false;
    this.cdRef.detectChanges();
  }

  ngAfterViewInit(): void {
      this.init = true;
  }

  chartModeSelected(chartModeSelected: any, index: number): void {
    if (this.init) {
        if ((this.surveyMasterSummaryPDModel.listQuestionModel[index] && this.surveyMasterSummaryPDModel.listQuestionModel[index].chartModeSelect !== chartModeSelected) || this._index !== index) {
        this.surveyMasterSummaryPDModel.listQuestionModel[index].chartModeSelect = chartModeSelected.chartMode;
        this.surveyMasterSummaryPDModel.listQuestionModel[index].defaultChart.chart = chartModeSelected.defaultChart;
        this._indexChangeChartType = index
        this._index = index
        }

        if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion) {
        this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.forEach(_el => {
            if ((_el.listQuestionModel[index] && _el.listQuestionModel[index].chartModeSelect !== chartModeSelected ) ||this._index !== index) {
            _el.listQuestionModel[index].chartModeSelect = chartModeSelected.chartMode;
            _el.listQuestionModel[index].defaultChart.chart = chartModeSelected.defaultChart;
            this._indexChangeChartType = index
            this._index = index
            }
        })
        }

        if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion) {
        this.surveyMasterSummaryPDModel.listSurveyCutQuestion.forEach(_el => {
            if ((_el.listQuestionModel[index] && _el.listQuestionModel[index].chartModeSelect !== chartModeSelected ) ||this._index !== index) {
            _el.listQuestionModel[index].chartModeSelect = chartModeSelected.chartMode;
            _el.listQuestionModel[index].defaultChart.chart = chartModeSelected.defaultChart;
            this._indexChangeChartType = index
            this._index = index
            }
        })
        }
        this.onChangeQuestionSetting.emit(this.surveyMasterSummaryPDModel);
    }
  }

  sortModeSelected(sortModeSelected: any, index: number): void {
    if (this.init) {
        const _sortType = sortModeSelected._sortType
        this.dataOrdered = sortModeSelected
        if ((this.surveyMasterSummaryPDModel.listQuestionModel[index] 
          && this.surveyMasterSummaryPDModel.listQuestionModel[index].sortModeSelect !== _sortType) 
          || this._index !== index || this.surveyMasterSummaryPDModel.listQuestionModel[index].diffSortModeSelected !== sortModeSelected._baseSurvey) {
        this.surveyMasterSummaryPDModel.listQuestionModel[index].sortModeSelect = _sortType
        this.surveyMasterSummaryPDModel.listQuestionModel[index].resetPercentagesCalculus = false;
        this.surveyMasterSummaryPDModel.listQuestionModel[index].diffSortModeSelected = sortModeSelected._baseSurvey;
        this._indexChangeChartType = index
        this._index = index
        }

        if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion) {
        this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.forEach(_el => {
            if ((_el.listQuestionModel[index] && _el.listQuestionModel[index].sortModeSelect !== _sortType) 
            || this._index !== index || _el.listQuestionModel[index].diffSortModeSelected !== sortModeSelected._baseSurvey) {
              _el.listQuestionModel[index].diffSortModeSelected
            _el.listQuestionModel[index].sortModeSelect = _sortType
            _el.listQuestionModel[index].resetPercentagesCalculus = false;
            _el.listQuestionModel[index].diffSortModeSelected = sortModeSelected._baseSurvey;
            this._indexChangeChartType = index
            this._index = index
            }
        })
        }

        if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion) {
        this.surveyMasterSummaryPDModel.listSurveyCutQuestion.forEach(_el => {
            if ((_el.listQuestionModel[index] && _el.listQuestionModel[index].sortModeSelect !== _sortType) 
            || this._index !== index || _el.listQuestionModel[index].diffSortModeSelected !== sortModeSelected._baseSurvey) {
            _el.listQuestionModel[index].sortModeSelect = _sortType
            _el.listQuestionModel[index].resetPercentagesCalculus = false;
            _el.listQuestionModel[index].diffSortModeSelected = sortModeSelected._baseSurvey;
            this._indexChangeChartType = index
            this._index = index
            }
        })
        }
        this.onChangeQuestionSetting.emit(this.surveyMasterSummaryPDModel);
    }
  }

  themeModeSelected(themeModeSelected: boolean, index: number): void {
    if (this.init) {
        if ((this.surveyMasterSummaryPDModel.listQuestionModel[index] && this.surveyMasterSummaryPDModel.listQuestionModel[index].themeModeSelect !== themeModeSelected) || this._index !== index) {
        this.surveyMasterSummaryPDModel.listQuestionModel[index].themeModeSelect = themeModeSelected
        this.surveyMasterSummaryPDModel.listQuestionModel[index].sortModeSelect = SortType.RESET;
        this._indexChangeChartType = index
        this._index = index
        this.dataOrdered = null;
        }

        if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion) {
        this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.forEach(_el => {
            if ((_el.listQuestionModel[index] && _el.listQuestionModel[index].themeModeSelect !== themeModeSelected) || this._index !== index) {
            _el.listQuestionModel[index].themeModeSelect = themeModeSelected
            _el.listQuestionModel[index].sortModeSelect = SortType.RESET;
            this._indexChangeChartType = index
            this._index = index
            this.dataOrdered = null;
            }
        })
        }

        if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion) {
        this.surveyMasterSummaryPDModel.listSurveyCutQuestion.forEach(_el => {
            if ((_el.listQuestionModel[index] && _el.listQuestionModel[index].themeModeSelect !== themeModeSelected) || this._index !== index) {
            _el.listQuestionModel[index].themeModeSelect = themeModeSelected
            _el.listQuestionModel[index].sortModeSelect = SortType.RESET;
            this._indexChangeChartType = index
            this._index = index
            this.dataOrdered = null;
            }
        })
        }
        this.onChangeQuestionSetting.emit(this.surveyMasterSummaryPDModel);
    }
  }

  needRestartChartType(index: number): boolean {
    if(this._indexChangeChartType !== -1 && index === this._indexChangeChartType){
      this._indexChangeChartType = -1
      return false
    }else {
      return true
    }
  }

  hideQuestion(id: number) {
    this.showUnhideDialog = true;
    this.unhideQuestionId = id;
  }

  hide() {
    if (this.unhideQuestionId) {
      this.onHideQuestion.emit(this.unhideQuestionId);
    }
    this.unhideQuestionId = null;
    this.showUnhideDialog = false;
  }

  isHideQuestion(questionId: number) {
    return this.hideQuestions.map(x => x.questionId).includes(questionId);
  }

  isMissingQuestion(questionId: number, parentQuestionId: number) {
    return this.missingQuestionIds ? this.missingQuestionIds.includes(questionId) || this.missingQuestionIds.includes(parentQuestionId) : false;
  }

  isVersionQuestionMissing(version: any, question: any) {
    if (version && version.length) {
      return version.includes(question.id) || version.includes(question.parentQuestionId);
    }
    return false;
  }

  onScroll(loop:number = 1): void {
    if (this.compareIndex < this.compareSurveyDataModel.listQuestionModel.length) {
      let extraIndex = 0;
      if (!this.includeSurvey.allResponsesSelected
          && this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.length === 0) {
        extraIndex = 1;
      }
      for (let index = 0; index < loop; index++) {
        if (this.compareSurveyDataModel.listSurveyVersionQuestion) {
          for (let j = 0; j < this.compareSurveyDataModel.listSurveyVersionQuestion.length; j++) {
            const compareVersionData = this.compareSurveyDataModel.listSurveyVersionQuestion[j];
            this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.find(x => x.surveyName === compareVersionData.surveyName).listQuestionModel.push(compareVersionData.listQuestionModel[this.compareIndex]);
          }
        }
        if (this.compareSurveyDataModel.listSurveyCutQuestion) {
          for (let j = 0; j < this.compareSurveyDataModel.listSurveyCutQuestion.length; j++) {
            const compareCutData = this.compareSurveyDataModel.listSurveyCutQuestion[j];
            this.surveyMasterSummaryPDModel.listSurveyCutQuestion[j + extraIndex].listQuestionModel.push(compareCutData.listQuestionModel[this.compareIndex]);
          }
        }
        this.compareIndex++;
      }
    }
  }

  translateSelected(vesrionSelected: string, index: number): void {
    this.onTranslate.emit(vesrionSelected);
  }

  _percentageSelected(isSelected: boolean, index: number){
    this.surveyMasterSummaryPDModel.listQuestionModel[index].percentageSelected = isSelected
    this.surveyMasterSummaryPDModel.listQuestionModel[index] = Object.assign({}, this.surveyMasterSummaryPDModel.listQuestionModel[index]);

    if (this.surveyMasterSummaryPDModel.listSurveyVersionQuestion) {
      this.surveyMasterSummaryPDModel.listSurveyVersionQuestion.forEach(_el => {
         _el.listQuestionModel[index].percentageSelected = isSelected
          _el.listQuestionModel[index] = Object.assign({}, _el.listQuestionModel[index]);
      })
    }

    if (this.surveyMasterSummaryPDModel.listSurveyCutQuestion) {
      this.surveyMasterSummaryPDModel.listSurveyCutQuestion.forEach(_el => {
          _el.listQuestionModel[index].percentageSelected = isSelected
          _el.listQuestionModel[index] = Object.assign({}, _el.listQuestionModel[index]);
      })
    }

    this.onChangeQuestionSetting.emit(this.surveyMasterSummaryPDModel);
  }

  getCanvasIdForAllCharts(questionId: number): string {
    return getCanvasIdForAllCharts(questionId);
  }

  showCompareCharting(question: MasterSummaryQuestionModel) {
    if (!this.isShowExploreCompareChartsMode) {
        return true;
    }

    const listChoiceQuestionType: string[] = [
        'SingleChoice', 'MultipleChoice', 'OpinionScale', 'Number'
    ];

    return listChoiceQuestionType.includes(question.answerType);
  }

  compareChartModeSelected(compareChartModeSelect: string, index: number): void {
    if (this.init) {
        if (this.surveyMasterSummaryPDModel.listQuestionModel[index] && this.surveyMasterSummaryPDModel.listQuestionModel[index].compareChartModeSelect !== compareChartModeSelect) {
            this.surveyMasterSummaryPDModel.listQuestionModel[index].compareChartModeSelect = compareChartModeSelect;
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/compare-version/compare-version.component.ts